// base libs
// import { Component } from '@angular/core';
import * as THREE from 'three';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { DragControls } from 'three/examples/jsm/controls/DragControls';

// third
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../_app/features/firestore-database-service/firestore-database.service";

// from project
import { AppEnvironmentHandler, environment } from '../../environments/environment';
import { EnviromentData } from '../../environments/environment';
import { AppVersionPanelComponent } from "../_jovdk-web/features/app-version-panel/app-version-panel.component";
import { ThreeJsBaseSceneComponent } from './../_jovdk-web-threejs/features/base-scene/threejs-base-scene.component';
import { NgFor, NgIf, isPlatformBrowser } from '@angular/common';
import { NavBarComponent } from "../_app/features/home/nav-bar/nav-bar.component";


import { Component, VERSION, ViewChildren, QueryList, AfterViewInit, OnDestroy, ContentChildren, inject, ViewChild, PLATFORM_ID } from '@angular/core';
import { ImgLoadingDirective } from '../_app/features/custom-directives/img-loading.directive';
import { forkJoin, Subscription } from 'rxjs';
import { ImageService } from './ImageService';
import { LocalizationService } from '../_jovdk-web/features/localization-service/localization-service.service';

@Component({
    selector: 'full-app',
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        AppVersionPanelComponent,
        ThreeJsBaseSceneComponent,
        NavBarComponent,
        ImgLoadingDirective,
    ],
    templateUrl: './full-app.component.html',
    styleUrl: './full-app.component.css',
})
export class FullAppComponent
{
    // dependencies
    _environmentData: EnviromentData = environment;
    _localizationService: LocalizationService = inject(LocalizationService);
    _imageService: ImageService = inject(ImageService);
    _isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

    // state
    _isLoadingContent = true;
    _isProd = AppEnvironmentHandler.IsProd();
    _isLocal = AppEnvironmentHandler.IsLocal();

    // parts
    @ViewChild('_threeJsBaseScene') _threeJsBaseScene!: ThreeJsBaseSceneComponent;

    // configs
    _projectInternalId = 't2pp-adds-01';

    _tokenData: TokenData = {
        Name: 'T1PP',
        Ticker: 'T1PP',

        SolTokenAddress: undefined,
        // SolTokenAddress: "Ax1DojUHqDdKahF19Roix9MWzoyhVxYiJzdbrYRYpump",
    };

    // https://pump.fun/coin/Ax1DojUHqDdKahF19Roix9MWzoyhVxYiJzdbrYRYpumppump
    // https://pump.fun/coin/Ax1DojUHqDdKahF19Roix9MWzoyhVxYiJzdbrYRYpump

    _socialData: SocialData = {
        DiscordServerLink: undefined,
        TelegramLink: undefined,
        TwitterUsername: "0xAdildos",
    };

    constructor()
    {
        this._imageService.imagesLoading$.subscribe(
            (value) =>
            {
                // console.log('>>>>>> images.length = ' + value);

                if (value == 0)
                    this._isLoadingContent = false;
            });

        this.HandleTokenDataSubscript();
    }

    HandleTokenDataSubscript = () =>
    {
        let needToStartSubscription = false;

        if (!this._tokenData.SolTokenAddress)
        {

            // if (this.)
        }
    }

    async ngAfterViewInit(): Promise<void>
    {
        if (!this._isBrowser)
            return;

        await import('flowbite');
        const { default: ApexCharts } = await import('apexcharts');

        //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
        //Add 'implements AfterViewInit' to the class.


        const getChartOptions = () =>
        {
            return {
                series: [35.1, 23.5, 2.4, 5.4],
                colors: ["#1C64F2", "#16BDCA", "#FDBA8C", "#E74694"],
                chart: {
                    height: 320,
                    width: "100%",
                    type: "donut",
                },
                stroke: {
                    colors: ["transparent"],
                    lineCap: "",
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                name: {
                                    show: true,
                                    fontFamily: "Inter, sans-serif",
                                    offsetY: 20,
                                },
                                total: {
                                    showAlways: true,
                                    show: true,
                                    label: "Unique visitors",
                                    fontFamily: "Inter, sans-serif",
                                    formatter: function (w: any)
                                    {
                                        const sum = w.globals.seriesTotals.reduce((a: any, b: any) =>
                                        {
                                            return a + b
                                        }, 0)
                                        return '$' + sum + 'k'
                                    },
                                },
                                value: {
                                    show: true,
                                    fontFamily: "Inter, sans-serif",
                                    offsetY: -20,
                                    formatter: function (value: any)
                                    {
                                        return value + "k"
                                    },
                                },
                            },
                            size: "80%",
                        },
                    },
                },
                grid: {
                    padding: {
                        top: -2,
                    },
                },
                labels: ["Direct", "Sponsor", "Affiliate", "Email marketing"],
                dataLabels: {
                    enabled: false,
                },
                legend: {
                    position: "bottom",
                    fontFamily: "Inter, sans-serif",
                },
                yaxis: {
                    labels: {
                        formatter: function (value: any)
                        {
                            return value + "k"
                        },
                    },
                },
                xaxis: {
                    labels: {
                        formatter: function (value: any)
                        {
                            return value + "k"
                        },
                    },
                    axisTicks: {
                        show: false,
                    },
                    axisBorder: {
                        show: false,
                    },
                },
            }
        }

        if (document.getElementById("donut-chart") && typeof ApexCharts !== 'undefined')
        {
            const chart = new ApexCharts(document.getElementById("donut-chart"), getChartOptions());
            chart.render();

            // Get all the checkboxes by their class name
            const checkboxes = document.querySelectorAll('#devices input[type="checkbox"]');

            // Function to handle the checkbox change event
            function handleCheckboxChange(event: any, chart: any)
            {
                const checkbox = event.target;
                if (checkbox.checked)
                {
                    switch (checkbox.value)
                    {
                        case 'desktop':
                            chart.updateSeries([15.1, 22.5, 4.4, 8.4]);
                            break;
                        case 'tablet':
                            chart.updateSeries([25.1, 26.5, 1.4, 3.4]);
                            break;
                        case 'mobile':
                            chart.updateSeries([45.1, 27.5, 8.4, 2.4]);
                            break;
                        default:
                            chart.updateSeries([55.1, 28.5, 1.4, 5.4]);
                    }

                } else
                {
                    chart.updateSeries([35.1, 23.5, 2.4, 5.4]);
                }
            }

            // Attach the event listener to each checkbox
            checkboxes.forEach((checkbox) =>
            {
                checkbox.addEventListener('change', (event) => handleCheckboxChange(event, chart));
            });
        }


    }

}


class TokenData
{
    Name!: string;
    Ticker!: string;
    SolTokenAddress?: string;

    // tokenDecimals: number;
}

export class SocialData
{
    DiscordServerLink?: string;
    TelegramLink?: string;
    TwitterUsername?: string;
}

class AssetMetaData
{
    AddressesByEnvironment!: { [key: string]: string | undefined };
}
